import {combineReducers} from "redux";
import appConfigReducer from "./appConfigReducer";

const rootReducer = combineReducers({
    appConfig: appConfigReducer
})

export default rootReducer